import { DEVICE_ROLES, SUBMENU_ROLES } from '../utils/roles'

export const MainMenuConst = {
  radiologist: 'radiologist',
  deviceMappings: 'deviceMappings',
  labDevices: 'labDevices',
  radiologyDevices: 'radiologyDevices',
  pathologist: 'pathologist',
  billing: 'billing',
}
export const devicesOptions = [
  {
    label: 'Device Mappings',
    value: 'deviceMappings',
    roles: [DEVICE_ROLES?.PRORITHM_READ],
  },
  {
    label: 'Lab Analyzers',
    value: 'labDevices',
    roles: [DEVICE_ROLES?.LAB_DEVICES_READ],
  },
  {
    label: 'Lab Analyzer Models',
    value: 'labDeviceModel',
    roles: [DEVICE_ROLES?.LAB_DEVICE_MODEL],
  },
  {
    label: 'Radiology Devices',
    value: 'radiologyDevices',
    roles: [DEVICE_ROLES?.RADIOLOGY_DEVICE_READ],
  },
  {
    label: 'Model Parameter Mappings',
    value: 'parameterMappings',
    roles: [DEVICE_ROLES?.PARAMETER_MAPPINGS],
  },
]
export const partnersOptions = [
  { label: 'Doctor', value: 'doctor', roles: [SUBMENU_ROLES?.DOCTOR_READ] },
  {
    label: 'B2B Partners',
    value: 'referredOut',
    roles: [SUBMENU_ROLES?.B2B_PARTNERS_READ],
  },
  {
    value: 'pathologist',
    label: 'Pathologist',
    roles: [SUBMENU_ROLES?.PATHOLOGIST_READ],
  },
  {
    value: 'radiologist',
    label: 'Radiologist',
    roles: [SUBMENU_ROLES?.RADIOLOGIST_READ],
  },
]
export const subdropdownitems = {
  radiology: 'radiology',
  bedManagementAdmin: 'bedManagementAdmin',
  devices: 'devices',
  partners: 'partners',
  doctor: 'doctor',
  referredOut: 'referredOut',
  labDeviceModel: 'labDeviceModel',
  parameterMappings: 'parameterMappings',
}
export const intent = {
  odooLogin: 'odooLogin',
  pharmacyLocation: 'pharmacyLocation',
  getLabInchargeList: 'getLabInchargeList',
}
export const keyConstants = {
  tab: 'Tab',
  enter: 'Enter',
  arrowUp: 'ArrowUp',
  arrowDown: 'ArrowDown',
}
export const selectedLocationId = 'selectedLocationId'
export const administration = 'administration'
export const searchByPatient = 'Search by Patient UHID'
export const dropDownMenuKeys = {
  filter: 'filter',
  action: 'action',
  export: 'export',
  delete: 'delete',
  archive: 'archive',
  active: 'active',
  inActive: 'inactive',
  filterKey: 'Filter',
  actionKey: 'Action',
  exportKey: 'Export',
  deleteKey: 'Delete',
  archiveKey: 'Archive',
  activeKey: 'Active',
  inActiveKey: 'Inactive',
}
export const noDataMessage = 'No Data Found'
export const searchConstant = {
  muhid: 'MUHID',
  identifier: 'identifier',
  Name: 'Name',
  name: 'name',
  Mobile: 'Mobile',
  phone: 'phone',
  unknown: 'unknown',
}
